export const frontmatter = {
    "draft": true,
    "title": "First steps by role",
    "description": "A getting started guide in OnnIA based on your role: Team Owner, Admin, Creator, Tester, and Enterprise Tenant roles.",
    "sidebar_label": "First steps by role",
    "sidebar_group": "quickstart",
    "sidebar_order": 2
}

export const toc = [
    {
        "depth": 2,
        "id": "types-of-spaces-in-onnia",
        "value": "Types of spaces in OnnIA"
    },
    {
        "depth": 2,
        "id": "roles-in-the-default-tenant",
        "value": "Roles in the Default Tenant"
    },
    {
        "depth": 3,
        "id": "team-owner",
        "value": "Team Owner"
    },
    {
        "depth": 3,
        "id": "project-owner",
        "value": "Project Owner"
    },
    {
        "depth": 3,
        "id": "team-admin",
        "value": "Team Admin"
    },
    {
        "depth": 3,
        "id": "creator-developer",
        "value": "Creator (Developer)"
    },
    {
        "depth": 3,
        "id": "tester",
        "value": "Tester"
    },
    {
        "depth": 2,
        "id": "roles-in-the-enterprise-tenant",
        "value": "Roles in the Enterprise Tenant"
    },
    {
        "depth": 3,
        "id": "enterprise-tenant-user",
        "value": "Enterprise Tenant User"
    },
    {
        "depth": 3,
        "id": "enterprise-tenant-owner",
        "value": "Enterprise Tenant Owner"
    },
    {
        "depth": 3,
        "id": "system-super-admin",
        "value": "System Super Admin"
    }
]